import { CheckBox as CheckBoxIcon } from '@mui/icons-material';

const CheckBox = (): JSX.Element => <CheckBoxIcon fontSize="inherit" />;

export default CheckBox;
